const googleDriveRegex = /https?:\/\/(?:www\.)?drive\.google\.com\/[^\s]+/gi;
const dropboxRegex = /https?:\/\/(?:www\.)?dropbox\.com\/[^\s]+/gi;

const linkMaskRegex = new RegExp(`${googleDriveRegex.source}|${dropboxRegex.source}`, 'gi');

export const restrictGoogleDriveDropboxLinks = currentText => {
  return currentText.replace(linkMaskRegex, match => 'X'.repeat(match.length));
};

export const onBlurHiddenGoogleDriveDropboxLinks = (currentText, style) => {
  return currentText.split(/(X{6,})/).map((part, i) =>
    /^X{6,}$/.test(part) ? (
      <span key={i} className={style}>
        {part}
      </span>
    ) : (
      part
    )
  );
};
